export default (task) => ({
    ...task,
    delta: Date.parse(task.responseTime) - Date.now(),
});
